import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { ActionWrapper } from '../inventory.styled';

const SelectionArea = ({
  productHasSingleOrNoOptions,
  isSingleOptionProduct,
  handleOptionsChange,
  hideSelectorLabels,
  isEditingResponse,
  decrementQuantity,
  incrementQuantity,
  openOptionsModal,
  getOptionValue,
  handleQuantity,
  isOutOfStock,
  quantity,
  options,
  isList,
  inForm,
  price
}) => {
  const classes = {
    selectors: hideSelectorLabels ? 'selectors sm' : 'selectors',
    view: isList ? 'list' : '',
  };

  return (
    <ActionWrapper className={classes.view}>
      <div className={classes.selectors}>
        {productHasSingleOrNoOptions && (
          <>
            {isSingleOptionProduct && (
              <div className="dropdown">
                <span className="label" title={options[0].label}>{options[0].label}{isList && ':'}</span>

                <Dropdown
                  onChange={(e, { value }) => handleOptionsChange(options[0].label, value)}
                  value={getOptionValue(options[0].label)}
                  disabled={!inForm || isEditingResponse}
                  placeholder={options[0].label}
                  options={options[0].options}
                  data-testid="options"
                  className="drop-down"
                  selection
                />
              </div>
            )}

            <div className="flex_col">
              <span className="label">Quantity{isList && ':'}</span>

              <div className="btn-left">
                <button disabled={!inForm || isEditingResponse} onClick={decrementQuantity} className="less" type="button">
                  -
                </button>

                <input
                  disabled={!inForm || isOutOfStock || isEditingResponse}
                  onChange={handleQuantity}
                  data-testid="quantity"
                  value={quantity}
                  type="number"
                  min={0}
                />

                <button
                  disabled={!inForm || isOutOfStock || isEditingResponse}
                  onClick={incrementQuantity}
                  className="add"
                  type="button">
                  +
                </button>
              </div>
            </div>
          </>
        )}

        {options.length > 1 && (
          <button type="button" className="label" onClick={openOptionsModal}>
            Select options
          </button>
        )}
      </div>

      {(price && isList) && (
        <div className="price">
          <span>{price}</span>
        </div>
      )}
    </ActionWrapper>
  );
};

SelectionArea.defaultProps = {
  hideSelectorLabels: false,
  isList: false,
};

SelectionArea.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  productHasSingleOrNoOptions: PropTypes.bool.isRequired,
  isSingleOptionProduct: PropTypes.bool.isRequired,
  handleOptionsChange: PropTypes.func.isRequired,
  isEditingResponse: PropTypes.bool.isRequired,
  incrementQuantity: PropTypes.func.isRequired,
  decrementQuantity: PropTypes.func.isRequired,
  openOptionsModal: PropTypes.func.isRequired,
  handleQuantity: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  isOutOfStock: PropTypes.bool.isRequired,
  quantity: PropTypes.number.isRequired,
  hideSelectorLabels: PropTypes.bool,
  price: PropTypes.string.isRequired,
  inForm: PropTypes.bool.isRequired,
  isList: PropTypes.bool,
};

export default SelectionArea;